import React from 'react';
import { Spin, Icon } from 'antd';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';

const LoadingSpinner = ({ size, style = {} }) => (
    <FlexContainer grow={1} align='center' justify='center'>
        <Spin indicator={<Icon size={size} type='loading' style={{ fontSize: 24, ...style }} spin />} />
    </FlexContainer>
);

const Loading = ({ loading, children, Component = LoadingSpinner, ...props }) => {
    if (loading) { return <Component {...props} />; }
    return children || null;
};

export default Loading;
